import { FC } from 'react';
import { useNavigate } from 'react-router';
import { Outlet } from 'react-router-dom';
import { Button } from '@mui/material';
import { Header } from '../../components/header/Header';
import { TabsPanel } from '../../components/tabs/TabsPanel';
import { routesNames } from '../../utils/constants';
import { useStyles } from './main.styles';

export const Main: FC = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <div>
      <Header />
      <div className={classes.mainContent}>
        <div className={classes.contentHeaderText}>My opportunities</div>
        <div className={classes.tabsBlock}>
          <TabsPanel />
          <Button
            className={classes.createBtn}
            onClick={(): void => navigate(routesNames.createOpportunity)}
          >CREATE NEW OPPORTUNITY
          </Button>
        </div>
        <Outlet />
      </div>
    </div>
  );
};
